module.exports = __webpack_public_path__ + "2a2fe269ea5914502dc0d47f15717b65.svg";